
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/locations",
      function () {
        return require("private-next-pages/locations/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/locations"])
      });
    }
  